import React, {useContext, useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';
import AuthProvider from "../services/AuthProvider";
import UiInputMoney from "../components/Form/UiInputMoney";
import UiSelectPicker from "../components/Form/UiSelectPicker";

const acessoListBase: any = {
    1: 'Master',
    2: 'Vendedor',
    3: 'Supervisor',
};
const acessoList = Object.keys(acessoListBase).map((key) => {
    return { id: key, title: acessoListBase[key] };
})


export default function MovimentacaoForm(props: any){
    const { user } = useContext<any>(AuthProvider);

    const parentProps = props.parentProps;
    const methods = useForm({
        defaultValues: props.data
    });
    const { register, handleSubmit, watch, setValue } = methods;
    const allData = watch();

    return (
        <FormContainer size="sm" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data ? 'Editar Movimentação' : 'Nova Movimentação'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <UiInputText size={12} name="descricao" label="Descrição"/>
                            <UiInputMoney size={2} name="valor" label="Preço"/>
                            <UiInputText size={12} name="data" label="Data"/>
                            <UiInputText size={12} name="competencia" label="Competencia"/>
                            <UiSelectPicker size={12} name="tag" label="Tags"
                                            extraDataOnCreate={{ tipo: 1 }}
                                            extraDataOnFilter={{
                                                "name": 'tipo',
                                                "v": '1',
                                                "v2": null,
                                                "op": 'like'
                                            }}
                                            router="tag" idField="id" titleField="titulo"/>
                        </div>
                    </FormContainer.Body>

                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}